<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <div class="container py-4">
            <SearchCollapse :is-bg-white="true">
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 md:col-span-6 relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-10 ml-2">
                            {{ $t('person.givenName') }}
                        </div>
                        <b-form-input
                            v-model="search.employeeGivenName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchEmployeesAtWork"
                        >
                        </b-form-input>
                    </div>

                    <div class="col-span-12 md:col-span-6 relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-10 ml-2">
                            {{ $t('person.familyName') }}
                        </div>
                        <b-form-input
                            v-model="search.employeeFamilyName"
                            class="focus:ring-0 border-gray-300 h-11"
                            @keyup.enter="searchEmployeesAtWork"
                        >
                        </b-form-input>
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-4">
                    <div class="col-span-12 md:col-span-3 position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.thisDay') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="after"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-3 position-relative">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-2 ml-2">
                            {{ $t('filter.toDay') }}
                        </div>
                        <InputBox
                            class="px-0"
                            :model-form="search"
                            model-name="before"
                            :no-margin-top="true"
                            type="date"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-6">
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 w-50 focus:outline-none">
                            <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchEmployeesAtWork">
                        </button>
                        <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 w-50 focus:outline-none">
                            <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetEmployeeSearchInfo">
                        </button>
                    </div>
                </div>
            </SearchCollapse>
        </div>


        <!--  desktop version  -->
        <table class="w-full d-none d-md-table">
            <thead class="bg-lightGray h-11">
            <tr>
                <th class="d-none d-md-table-cell pl-3">{{$t('id')}}</th>
                <th>{{ $t('name') }}</th>
                <th>{{ $t('employee.position') }}</th>
                <th class="d-none d-md-table-cell">{{ $t('atWork.jobTime') }}</th>
                <th>{{ $t('atWork.started') }}</th>
                <th>{{ $t('atWork.ended') }}</th>
                <th>{{ $t('atWork.atWork') }}</th>
                <th class="d-none d-xl-table-cell">{{ $t('atWork.reason') }}</th>
                <th>{{ $t('atWork.lateTime') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(employeeAtWork, index ) of getEmployeeAtWorks" :key="index" class="h-11">
                <td class="d-none d-md-table-cell pl-3">
                    {{ employeeAtWork.id }}
                </td>
                <td>
                    <div class="d-flex align-items-center">
                        <img
                            :src="employeeAtWork.employee.image ? url + employeeAtWork.employee.image.contentUrl : ''"
                            style="border-radius: 50%;"
                            height="34px"
                            alt=""
                            @click="setModal(employeeAtWork.employee.givenName, url + employeeAtWork.employee.image.contentUrl)"
                            class="d-none d-md-table-cell"
                        >
                        <router-link :to="$i18nHelper.getUrl('employee/' + employeeAtWork.employee.id)" class="d-none d-sm-block font-bold ml-2">
                            &ensp;{{ employeeAtWork.employee.givenName + ' ' + employeeAtWork.employee.familyName + ' ' + employeeAtWork.employee.additionalName }}
                        </router-link>
                        <router-link :to="$i18nHelper.getUrl('employee/' + employeeAtWork.employee.id)" class="d-block d-sm-none ml-1">
                            {{ employeeAtWork.employee.givenName }}
                        </router-link>
                    </div>
                </td>
                <td v-if="employeeAtWork.employee.employeePositions">
                    {{ employeeAtWork.employee.employeePositions[0].name}}
                </td>

                <td v-if="employeeAtWork.employee.employeeInformation !== null" class="d-none d-md-table-cell">
                    {{ employeeAtWork.employee.employeeInformation.startTime }}-{{ employeeAtWork.employee.employeeInformation.endTime }}
                </td>
                <td v-if="employeeAtWork.startedAt !== null">
                    <span v-if="employeeAtWork.lateTime" style="color: red">{{ employeeAtWork.startedAt }}</span>
                    <span v-else style="color: #0A8C1A">{{ employeeAtWork.startedAt }}</span>
                </td>
                <td v-else> - </td>

                <td v-if="employeeAtWork.endedAt !== null">
                    <span v-if="hasEndedAtTime(employeeAtWork)" style="color: #0A8C1A">{{ employeeAtWork.endedAt }}</span>
                    <span v-else style="color: red">{{ employeeAtWork.endedAt }}</span>
                </td>
                <td v-else> - </td>

                <td>
                    <span v-if="employeeAtWork.hasAtWork" style="color: #0A8C1A">{{ $t('yes') }}</span>
                    <span v-else style="color: red">{{ $t('no') }}</span>
                </td>

                <td class="d-none d-xl-table-cell" style="max-width: 200px; cursor: pointer" @click="showReason(employeeAtWork.reason)">
                    {{ employeeAtWork.reason ? employeeAtWork.reason.substring(0, 30) + '...' : '-' }}
                </td>

                <td>
                    <span v-if="employeeAtWork.lateTime" style="color: red">{{ getLateTime(employeeAtWork) }}</span>
                    <span v-else> - </span>
                </td>

            </tr>
            </tbody>
        </table>

        <!--  mobile version  -->
        <table class="w-full d-md-none">
            <tbody v-for="(employeeAtWork, index ) of getEmployeeAtWorks" :key="index" style="border-bottom: #444444 solid 5px">
                <tr class="h-11">
                    <td class="font-weight-bold pl-2">{{$t('id')}}</td>
                    <td class="">
                        {{ employeeAtWork.id }}
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('name') }}</td>
                    <td>
                        <div class="d-flex align-items-center">
                            <img
                                :src="employeeAtWork.employee.image ? url + employeeAtWork.employee.image.contentUrl : ''"
                                style="border-radius: 50%;"
                                height="34px"
                                alt=""
                                @click="setModal(employeeAtWork.employee.givenName, url + employeeAtWork.employee.image.contentUrl)"
                                class="d-none d-md-table-cell"
                            >
                            <router-link :to="$i18nHelper.getUrl('employee/' + employeeAtWork.employee.id)" class="d-none d-sm-block ml-2">
                                &ensp;{{ employeeAtWork.employee.givenName + ' ' + employeeAtWork.employee.familyName + ' ' + employeeAtWork.employee.additionalName }}
                            </router-link>
                            <router-link :to="$i18nHelper.getUrl('employee/' + employeeAtWork.employee.id)" class="d-block d-sm-none ml-1">
                                {{ employeeAtWork.employee.givenName }}
                            </router-link>
                        </div>
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('employee.position') }}</td>
                    <td v-if="employeeAtWork.employee.employeePositions">
                        {{ employeeAtWork.employee.employeePositions[0].name}}
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.jobTime') }}</td>
                    <td v-if="employeeAtWork.employee.employeeInformation !== null">
                        {{ employeeAtWork.employee.employeeInformation.startTime }}-{{ employeeAtWork.employee.employeeInformation.endTime }}
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.started') }}</td>
                    <td v-if="employeeAtWork.startedAt !== null">
                        <span v-if="employeeAtWork.lateTime" style="color: red">{{ employeeAtWork.startedAt }}</span>
                        <span v-else style="color: #0A8C1A">{{ employeeAtWork.startedAt }}</span>
                    </td>
                    <td v-else> - </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.ended') }}</td>
                    <td v-if="employeeAtWork.endedAt !== null">
                        <span v-if="hasEndedAtTime(employeeAtWork)" style="color: #0A8C1A">{{ employeeAtWork.endedAt }}</span>
                        <span v-else style="color: red">{{ employeeAtWork.endedAt }}</span>
                    </td>
                    <td v-else> - </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.atWork') }}</td>
                    <td>
                        <span v-if="employeeAtWork.hasAtWork" style="color: #0A8C1A">{{ $t('yes') }}</span>
                        <span v-else style="color: red">{{ $t('no') }}</span>
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.reason') }}</td>
                    <td style="max-width: 180px">
                        {{ employeeAtWork.reason }}
                    </td>
                </tr>

                <tr class="h-11">
                    <td class="font-weight-bold px-2">{{ $t('atWork.lateTime') }}</td>
                    <td>
                        <span v-if="employeeAtWork.lateTime" style="color: red">{{ getLateTime(employeeAtWork) }}</span>
                        <span v-else> - </span>
                    </td>
                </tr>
            </tbody>
        </table>

        <ModalWithPicture id="employee_picture" :img="itemImageUrl" :title="employeeGivenName"/>

        <Modal
            :text="modalText"
            id="modal_show3"
        />

        <PaginationRow
            :search="search"
            base-url="employee_at_works"
            method-name="searchEmployeeAtWorks"
            :total-items="getEmployeeAtWorksTotalCount"
        ></PaginationRow>
    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import accessMixin from "@/mixin/accessMixin";
import PaginationRow from "@/components/PaginationRow";
import {mapActions, mapGetters} from "vuex";
import SearchCollapse from "@/components/SearchCollapse";
import ModalWithPicture from "../../components/html/ModalWithPicture";
import validatorMixin from "@/mixin/validatorMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import Modal from "@/components/html/Modal.vue";
import InputBox from "@/components/InputBox.vue";

export default {
    name: "AtWorkList",
    components: {
        InputBox,
        Modal,
        PaginationRow,
        Row,
        SearchCollapse,
        ModalWithPicture,
    },
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    computed: {
        ...mapGetters(['getEmployeeAtWorks', 'getEmployeeAtWorksTotalCount'])
    },
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees'},
                {name: 'atWork.title'},
            ],
            isLoading: false,
            employeeGivenName: '',
            itemImageUrl: '',
            url: process.env.VUE_APP_API_URL,
            modalText: '',
            search: {
                after: '',
                before: '',
                employeeGivenName: '',
                employeeFamilyName: '',
                page: 1
            },
        }
    },
    methods: {
        ...mapActions(['searchEmployeeAtWorks', 'setBreadcrumbItems']),
        hasEndedAtTime(employeeAtWork) {
            return employeeAtWork.endedAt >= employeeAtWork.employee.employeeInformation.endTime
        },
        getLateTime(employeeAtWork) {
            let hours = Math.floor(employeeAtWork.lateTime / 60);
            let minutes = Math.floor(employeeAtWork.lateTime % 60);

            return hours + ' ' + this.$t('atWork.hour') + ' ' + minutes + ' ' + this.$t('atWork.minute')
        },
        callAfterModal() {
            this.$bvModal.show('after')
        },
        callBeforeModal() {
            this.$bvModal.show('before')
        },
        setModal(givenName, url) {
            this.employeeGivenName = givenName
            this.itemImageUrl = url
            this.$bvModal.show('employee_picture')
        },
        searchEmployeesAtWork() {
            this.$root.showOverlay = true
            this.searchEmployeeAtWorks(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetEmployeeSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchEmployeesAtWork()
        },
        getTodayDate() {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + 1
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        showReason(reason) {
            if (reason) {
                this.modalText = reason
                this.$bvModal.show('modal_show3')
            }
        }
    },
    created() {
        this.search.after = this.getTodayDate() + ' 00:00:00'
        this.search.before = this.getTodayDate() + ' 23:59:59'
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

img {
    cursor: pointer;
}

@media (min-width: 576px) {
    .mr-md-1 {
        margin-right: 0.25rem !important;
    }
}
</style>